// Which failed jobs still deserve an error card on a screen. The journal always shows everything;
// screens hide errors that no longer apply (owner, 2026-10-17):
//   - a key / permission error from before the last successful key check (e.g. the key was replaced);
//   - an error superseded by a newer attempt of the same job (same type, story and language).
import type { AdminJob, AdminReadiness } from '@fonus/shared';

const KEY_STEP: Record<string, 'claude' | 'elevenlabs'> = {
  ELEVENLABS_AUTH: 'elevenlabs',
  ELEVENLABS_PERMISSION: 'elevenlabs',
  BUDGET_UNAVAILABLE: 'elevenlabs',
  CLAUDE_AUTH: 'claude',
  CLAUDE_PERMISSION: 'claude',
  CLAUDE_MODEL: 'claude',
};

export function isStaleError(
  job: AdminJob,
  readiness: AdminReadiness | undefined,
  all: AdminJob[] = [],
): boolean {
  if (job.status !== 'FAILED') return true;
  const at = new Date(job.finishedAt ?? job.createdAt).getTime();
  const step = job.errorCode ? KEY_STEP[job.errorCode] : undefined;
  if (step && readiness?.checkedAt) {
    const ok = readiness.steps.find((s) => s.id === step)?.status === 'done';
    if (ok && new Date(readiness.checkedAt).getTime() > at) return true;
  }
  return all.some(
    (o) =>
      o.id !== job.id &&
      o.type === job.type &&
      o.lang === job.lang &&
      o.storyId === job.storyId &&
      new Date(o.createdAt).getTime() > new Date(job.createdAt).getTime(),
  );
}
